export enum PopupType {
  Success = 'success',
  Warning = 'warning',
}
